import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  createFilterOptions,
  TextField,
  Typography,
  Radio,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Category, CheckBox, Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import NormalTable from "../../../Component/NormalTable";
import { toast } from "react-toastify";

const GroupCatMapRoleDeptMappingModal = ({
  mode,
  handleCloseClick,
  editData,
  getById,
}) => {
  const [loading, setLoading] = useState(false);
  const [roles, setRoleId] = useState([]);
  const [person, setPerson] = useState([]);
  const [personSelect, setPersonSelect] = useState([]);
  const [roleSelect, setRoleSelect] = useState([]);
  const [userGroup, setUserGroup] = useState([]);
  const [depart, setDepart] = useState([]);
  const [notifTemp, setNotificationTemp] = useState([]);
  const [notificationType, setNotificationType] = useState([]);
  const [uncheckedRoles, setUncheckedRoles] = useState(null);
  console.log("uncheckedRoles", uncheckedRoles);

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    const roleLink = masterAPI["roles"].link;
    await axiosPrivate
      .get(`${roleLink}`)
      .then((res) => {
        setLoading(false);
        setRoleId(res.data.result);
        console.log("role", res.data);
      })
      .catch((e) => {
        setRoleId([]);
        setLoading(false);
        console.log(e, "roleerror");
      });

    const link = masterAPI["userGroup"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false);
        setUserGroup(res.data.result);
      })
      .catch((e) => {
        setUserGroup([]);
        setLoading(false);
        console.log(e, "UserGroup");
      });
    const linkDepart = masterAPI["department"].link;
    await axiosPrivate
      .get(`${linkDepart}`)
      .then((res) => {
        setLoading(false);
        setDepart(res.data.result);
      })
      .catch((e) => {
        setDepart([]);
        setLoading(false);
        console.log(e, "department");
      });
    const personlink = masterAPI["person"].link;
    await axiosPrivate
      .get(`${personlink}`)
      .then((res) => {
        setLoading(false);
        console.log("person", res.data.result);
        setPerson(res.data.result);
      })
      .catch((e) => {
        setPerson([]);
        setLoading(false);
        console.log(e, "setPerson");
      });
    const notificationTempLink = masterAPI["notificationtemplate"].link;
    await axiosPrivate
      .get(`${notificationTempLink}`)
      .then((res) => {
        setLoading(false);
        setNotificationTemp(res.data.result);
      })
      .catch((e) => {
        setNotificationTemp([]);
        console.log(e, "errortemp");
      });
    const notType = masterAPI["selectList"].notificationType;
    await axiosPrivate
      .get(`${notType}`)
      .then((res) => {
        setLoading(false);
        setNotificationType(res.data);
        console.log(res.data, "type");
      })
      .catch((e) => {
        setNotificationType([]);
        setLoading(false);
        console.log(e, "type");
      });
    if (mode === "Edit" && editData) {
      setPersonSelect(
        editData.userGroupWithRoleandDepartmentWithListofPersonList || []
      );
      setRoleSelect(
        editData.userGroupWithRoleandDepartmentWithListofRolesList || []
      );
    }
  };

  const initialValue = {
    code: mode === "Edit" ? editData.code : "",
    roleId: mode === "Edit" ? editData.roleId : null,
    notificationTemplateId:
      mode === "Edit" ? editData.notificationTemplateId : null,
    notificationtype: mode === "Edit" ? editData.notificationtype : "Email",
    departmentId: mode === "Edit" ? editData.departmentId : null,
    userGroupId: mode === "Edit" ? editData.userGroupId : "",
    userGroupWithRoleDepartmentName:
      mode === "Edit" ? editData.userGroupWithRoleDepartmentName : "",
    userGroupWithRoleandDepartmentWithListofPersonList:
      mode === "Edit"
        ? editData.userGroupWithRoleandDepartmentWithListofPersonList
        : [],
    userGroupWithRoleandDepartmentWithListofRolesList:
      mode === "Edit"
        ? editData.userGroupWithRoleandDepartmentWithListofRolesList
        : [],
  };
  console.log("editData", editData);

  const onSubmit = async (value) => {
    const userGroupWithRoleandDepartmentWithListofPersonList = personSelect.map(
      (p) => ({
        ...(p.id ? { id: p.id } : {}),
        personId: p.personId,
      })
    );
    const userGroupWithRoleandDepartmentWithListofRolesList = roleSelect.map(
      (r) => ({
        ...(r.id ? { id: r.id } : {}),
        roleId: r.roleId,
      })
    );
    const payload = {
      ...value,
      userGroupWithRoleandDepartmentWithListofPersonList,
      userGroupWithRoleandDepartmentWithListofRolesList,
    };
    console.log("payload", payload);
    setLoading(true);
    const createLink = masterAPI["usergroupwithroleanddepartment"].create;
    const updateLink = masterAPI["usergroupwithroleanddepartment"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, payload)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "createAC");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...payload,
      };
      console.log("updateac", updateAC);
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "updateAC");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  const personColumns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        const id = cell.row.original.id;
        const isChecked = personSelect.some((person) => person.personId === id);
        return (
          <Checkbox
            checked={isChecked}
            onClick={() => handleCheckPerson(cell.row.original)}
          />
        );
      },
    },
    {
      Header: "Persons",
      accessor: "personName",
      // disableFilters: true,
    },
  ];
  const handleCheckPerson = (person) => {
    setPersonSelect((prev) => {
      const exists = prev.find((p) => p.personId === person.id);
      if (exists) {
        if (mode === "Edit") {
          const personObject =
            editData.userGroupWithRoleandDepartmentWithListofPersonList.find(
              (p) => p.personId === person.id
            );
          confirmDeletePerson(personObject.id);
        }
        return prev.filter((p) => p.personId !== person.id);
      }
      return [...prev, { personId: person.id }];
    });
  };
  const roleColumns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        const id = cell.row.original.id;
        const isChecked = roleSelect.some((role) => role.roleId === id);
        return (
          <Checkbox
            checked={isChecked}
            onClick={() => handleCheckRole(cell.row.original)}
          />
        );
      },
    },
    {
      Header: "Roles",
      accessor: "name",
    },
  ];

  const handleCheckRole = (role) => {
    setRoleSelect((prev) => {
      const exists = prev.find((p) => p.roleId === role.id);
      if (exists) {
        if (mode === "Edit") {
          const roleObjectFromEditData =
            editData.userGroupWithRoleandDepartmentWithListofRolesList.find(
              (r) => r.roleId === role.id
            );
          confirmDeleteRole(roleObjectFromEditData.id);
        }
        return prev.filter((p) => p.roleId !== role.id);
      }

      return [...prev, { roleId: role.id }];
    });
  };

  const confirmDeleteRole = (id) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to uncheck?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handleDeleteRole(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      }
    );
  };
  const confirmDeletePerson = (id) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to uncheck?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handleDeletePerson(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      }
    );
  };
  const handleDeleteRole = async (roleId) => {
    const roleDelete =
      masterAPI["userGroupWithRoleandDepartmentWithListofRoles"].delete;
    await axiosPrivate
      .delete(`${roleDelete}/${roleId}`)
      .then((res) => {
        console.log(res);
        getById(editData.id);
        // toast.success("Deleted Successfully");
      })
      .catch((e) => {
        console.log(e, "error task delete");
      });
  };
  const handleDeletePerson = async (personId) => {
    const personDelete =
      masterAPI["userGroupWithRoleandDepartmentWithListofPerson"].delete;
    await axiosPrivate
      .delete(`${personDelete}/${personId}`)
      .then((res) => {
        console.log(res);
        getById(editData.id);
        // toast.success("Deleted Successfully");
      })
      .catch((e) => {
        console.log(e, "error task delete");
      });
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? "Update User Group with role and person mapping"
            : "New User Group with role and person mapping"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="userGroupWithRoleDepartmentName"
                  placeholder="Enter Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  User Group
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={userGroup.length === 0}
                  options={userGroup}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.userGroupName}
                  value={
                    userGroup.find((p) => p.id === values.userGroupId) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("userGroupId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="userGroupId"
                      placeholder="Select User Group"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              {/* <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Type
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={notificationType.length === 0}
                  options={notificationType}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text}
                  value={
                    notificationType.find(
                      (p) => p.value === values.notificationtype
                    ) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("notificationtype", value.value);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="notificationtype"
                      placeholder="Select Notification Type"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                                          <CircularProgress color="inherit" size={20} />
                                                                        ) : null} 
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid> */}
              {/* <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Template
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={notifTemp.length === 0}
                  options={notifTemp}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.code}
                  value={
                    notifTemp.find(
                      (p) => p.id === values.notificationTemplateId
                    ) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("notificationTemplateId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="notificationTemplateId"
                      placeholder="Select Notification Template"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} 
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid> */}
              {/* <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Role
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={roles.length === 0}
                  options={roles}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.name}
                  value={roles.find((p) => p.id === values.roleId) || null}
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("roleId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="roleId"
                      placeholder="Select role"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
              {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} 
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid> */}

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <NormalTable data={roles} columns={roleColumns} filt={true} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <NormalTable
                    data={person}
                    columns={personColumns}
                    filt={true}
                  />
                </Grid>
              </Grid>

              {/* <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Department
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={depart.length === 0}
                  options={depart}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.departmentName}
                  value={
                    depart.find((p) => p.id === values.departmentId) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("departmentId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="departmentId"
                      placeholder="Select Department"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
              {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} 
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid> */}
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default GroupCatMapRoleDeptMappingModal;
